import ActionTypes from "../constants";
import * as api from '../api/index';
// import Swal from 'sweetalert2';
// import Router from "next/router";
import Toast from "../components/Toast"

export const getAllCustomer = (page,currentRowsPerPage, filter) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.getAllCustomer(page,currentRowsPerPage, filter).then(res => {
        // 
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.GETCUSTOMERSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETCUSTOMERFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETCUSTOMERFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const getAllCustomerLocal = (page,currentRowsPerPage) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.getAllCustomerLocal(page,currentRowsPerPage).then(res => {
        // 
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.GETCUSTOMERSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETCUSTOMERFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETCUSTOMERFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const getCustomerById = (id) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.getCustomerById(id).then(res => {
        // 
        if (JSON.parse(res).status == 200) {
            
            dispatch({
                type: ActionTypes.GETCUSTOMERBYIDSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            // Toast.fire({
            //     icon: 'success',
            //     title: 'Login Successful!'
            // })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETCUSTOMERBYIDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETCUSTOMERBYIDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const saveCustomer = (data,navigate) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.saveCustomer(data).then(res => {
        // 
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.SAVECUSTOMERSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Record Saved Successfully!'
            })
            navigate('/customers');
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.SAVECUSTOMERFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.SAVECUSTOMERFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const updateCustomer = (data, id, navigate) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.updateCustomer(data, id).then(res => {
        // 
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.UPDATECUSTOMERSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Record Updated Successfully!'
            })
            navigate('/customers');
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.UPDATECUSTOMERFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.UPDATECUSTOMERFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const toggleCustomer = (id) => async (dispatch) => {
    // alert('Login Auth Action');
    // dispatch({
    //     type: ActionTypes.LOADING,
    //     payload: true,
    // });
    const response = await api.toggleCustomer(id).then(res => {
        // 
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.TOGGLECUSTOMERSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Status Updated Successfully!'
            })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.TOGGLECUSTOMERFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.TOGGLECUSTOMERFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}